import { ruleDefinitionDefaults, defaultValidationTagRule, createValidator, createClashingRulesValidationFunctionNew } from './TagRulesCommon'

const ruleDefinition =
{
    ...ruleDefinitionDefaults,
    ruleType: "UpdateProductVariantMetafieldFromVariantOptionMapping",
    title: "Add Option Name As Variant Metafield Using Mapping Table",
    description: "Automatically set variant metafield based on a variant option by providing a mapping table to map option name to metafield value.",
    example: "Use this rule to unify varying variant options such as clothing sizes.",
    additional: [],
    legacy: false,
    inProgress: false,
    previewType: "ProductVariantMetafield",
    dataPermissions: ["products"],
    allowPreview: false,
    tags: ["Products", "Variants", "Metafields"],
    getDefaultRuleState: () => {
        return {
            name: null,
            trigger: "Automatic",
            settings: {
                ruleTypeId: "UpdateProductVariantMetafieldFromVariantOptionMapping",
                metafieldNamespaceAndKey: null,
                metafieldType: "single_line_text_field",
                optionName: "",
                removeMetafieldOnZeroQuantity: false,
                valueMappings: []
            }
        }
    },
    createValidator: (onAsyncError) => {
        return createValidator(
            onAsyncError,
            [defaultValidationTagRule,
                (rule, errors) => {

                    if (rule.settings.optionName == null || rule.settings.optionName === "") {
                        errors["optionName"] = "Option name is required";
                    }
                }
            ], createClashingRulesValidationFunctionNew("PRODUCTVARIANT"));
    }
};

export default ruleDefinition;